import { Box, Button, ColorOptions, IconButton, IconNew, SpacerNew, TextNew } from '@jfs/ui-new'
import * as React from 'react'
import { FC } from 'react'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import { AlertTypes } from './index'
import { styles } from './styles'
import { AlertProps } from './types'

const renderAlertModal = (
  type: AlertTypes,
  subTitle: string | undefined,
  onPress: () => void,
  onAction: () => void,
  buttonLabel: string,
): React.ReactElement => {
  const handleAction = () => {
    if (onAction) {
      onAction()
    }
  }

  return (
    <Box {...styles[type].outerContainer}>
      <Box {...styles[type].container}>
        <IconNew id={'INFO'} size={16} />
        <Box {...styles[type].textContainer}>
          <TextNew {...styles[type].subTitle}>{subTitle}</TextNew>
          {!buttonLabel && <SpacerNew size={12} />}
          <Button
            hide={!buttonLabel}
            testID="errorAction"
            onPress={handleAction}
            type={'IconLH'}
            color={'WHITE' as ColorOptions}
            textColor={'ERROR' as ColorOptions}
            title={buttonLabel}
          />
        </Box>
        <Box {...styles[type].closeIconContainer}>
          <IconButton id={'CLOSE'} size={16} color={'WHITE'} testID="errorClose" onPress={onPress} />
        </Box>
      </Box>
    </Box>
  )
}
const ErrorAlert: FC<AlertProps> = ({
  subTitle,
  onPress,
  type = AlertTypes.Error,
  visible = false,
  onAction,
  buttonLabel,
}: AlertProps) => {
  const action = onAction ?? onPress

  return (
    <Modal
      view={renderAlertModal(type, subTitle, onPress, action, buttonLabel || '')}
      visible={visible}
      onPress={onPress}
      type={ModalTypes.ERROR_TOP}
    />
  )
}

export default ErrorAlert
